import { apiRequestDev } from './apiRequest';

export const getTags = async (config, userId) => apiRequestDev(config, `/tags/all/${userId}`);

export const assignTags = async (config, userId, caseId, tags) => {
  return apiRequestDev(config, '/tags/assign', 'post', {
    user_id: userId,
    case_id: caseId,
    tags,
  });
};
